import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 外部ETサイトPDF一覧取得
export async function getOutsideEntrySitePDFs(id: string) {
  try {
    const path = "outsideEntrySitePDFs";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 外部ETサイトPDF詳細取得
export async function getOutsideEntrySitePDF(id: string) {
  try {
    const path = "outsideEntrySitePDF";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {}
}
// 外部ETサイトPDF詳細編集
export async function putOutsideEntrySitePDF(editData: EditDataDifine) {
  try {
    const path = "outsideEntrySitePDF";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      payment_method_id: editData.payment_method_id,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 外部ETサイト登録前にPDFファイル名の重複がないか確認
export async function checkPostOutsideEntrySitePDF(
  addData: {
    [key: string]: string | boolean | any[];
  },
  site_pdf_path_name: string
) {
  try {
    const path = "outsideEntrySitePDF/check";
    const bodys = { addData, site_pdf_path_name };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    const checkPostResponce = response.data.responce as string;
    const presigned_pdf_path_object = response.data
      .presigned_pdf_path_object as {
      fields: { [key: string]: string };
      url: string;
    };
    const destination_pdf_path_key = response.data
      .destination_pdf_path_key as string;
    return {
      checkPostResponce,
      presigned_pdf_path_object,
      destination_pdf_path_key,
    };
  } catch (error) {
    // logout();
    return {
      checkPostResponce: "false",
    };
  }
}
// 外部ETサイトPDF登録
export async function postOutsideEntrySitePDF(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntrySitePDF";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 外部ETサイトPDF削除
export async function deleteOutsideEntrySitePDF(id: string) {
  try {
    const path = "outsideEntrySitePDF";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
